import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialAlertCaution: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.71 25.905h1.53v3.05h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-25.91 6.1h27.43v1.52H2.28Zm24.39-9.15h1.52v3.05h-1.52Zm-1.53-3.04h1.53v3.04h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.53-3.05h1.53v3.05h-1.53Zm-1.52-3.05h1.52v3.05h-1.52Zm-1.52-3.04h1.52v3.04h-1.52Zm-1.53-1.53h1.53v1.53h-1.53Zm-3.05 22.86h3.05v-1.52h1.53v-3.05h-1.53v-1.53h-3.05v1.53h-1.52v3.05h1.52zm0-16.76h3.05v9.14h-3.05Zm0-7.62h3.05v1.52h-3.05Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.52 1.53h1.52v3.04h-1.52ZM9.9 7.615h1.53v3.05H9.9Zm-1.52 3.05H9.9v3.05H8.38Zm-1.52 3.05h1.52v3.05H6.86Zm-1.53 3.05h1.53v3.04H5.33Zm-1.52 3.04h1.52v3.05H3.81Zm-1.53 3.05h1.53v3.05H2.28Z\"/><path fill=\"currentColor\" d=\"M.76 25.905h1.52v3.05H.76Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialAlertCaution
